import { render } from "./employment-management.vue?vue&type=template&id=63bd2d6c&scoped=true&ts=true"
import script from "./employment-management.vue?vue&type=script&lang=ts"
export * from "./employment-management.vue?vue&type=script&lang=ts"

import "./employment-management.vue?vue&type=style&index=0&id=63bd2d6c&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bd2d6c"]])

export default __exports__